import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassPointerSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="compass-pointer-square, gps, direction"><path d="M20.5 4L4 4L4 20.5H20.5V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M8.75 15.3583L12 8.6416L15.25 15.3583L12 14.5583L8.75 15.3583Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCompassPointerSquare;
